import styled from "styled-components";

export const PrcToolttip = styled.div`
  width: 330px;
  border-radius: 0.4rem;
  border: solid 0.2rem #9bc2f6;
  background-color: #ffffff;
  position: absolute;
  right: 0;
  top: 2rem;
  z-index: 1;
  :after,
  :before {
    bottom: 100%;
    left: 90%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  :after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #fff;
    border-width: 0.6rem;
    margin-left: -0.6rem;
  }
  :before {
    border-color: rgba(155, 194, 246, 0);
    border-bottom-color: #9bc2f6;
    border-width: 0.9rem;
    margin-left: -0.9rem;
  }
  .row {
    display: flex;
    flex-direction:row;
    padding: 1.2rem 1.24rem 0.54rem 1.8rem;
    
  }
`;


export const PriceTip = styled.div`
  flex: 1;
`

